var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRedo = function SvgRedo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "delete copy"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle Copy 9",
    fill: "#fff",
    stroke: "current",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "redo icon",
    d: "M17.356 14.826a9.449 9.449 0 0 0-.937 1.128 7.733 7.733 0 0 0-.749 1.314 7.884 7.884 0 0 0-.493 1.483A7.275 7.275 0 0 0 15 20.372a8.42 8.42 0 0 0 .173 1.669 8.334 8.334 0 0 0 .57 1.744 10.748 10.748 0 0 0 1.057 1.822 14.466 14.466 0 0 0 1.635 1.9l.717.71.853.844q.451.446.922.917t.923.91l2.178 2.158 2.165-2.188q-1.119-1.113-2.165-2.148-.442-.439-.918-.9t-.927-.917q-.451-.451-.853-.85l-.717-.71a10.325 10.325 0 0 1-1.922-2.542 5.376 5.376 0 0 1-.645-2.455 4.291 4.291 0 0 1 .367-1.739 5.118 5.118 0 0 1 1.121-1.582 2.424 2.424 0 0 1 .466-.362 3.518 3.518 0 0 1 .628-.293 5.064 5.064 0 0 1 .764-.2 4.685 4.685 0 0 1 .876-.079 5.366 5.366 0 0 1 .982.1 5.112 5.112 0 0 1 1.037.315 6.346 6.346 0 0 1 1.059.575 6.854 6.854 0 0 1 1.047.868l2.282 2.3-3.575 3.568h9.4v-9.249l-3.552 3.488-2.292-2.306a8.147 8.147 0 0 0-1.582-1.4 7.9 7.9 0 0 0-1.634-.838 7.516 7.516 0 0 0-1.624-.4 12.141 12.141 0 0 0-1.548-.1 7.889 7.889 0 0 0-1.479.136 7.531 7.531 0 0 0-1.34.382 6.739 6.739 0 0 0-1.156.581 5.86 5.86 0 0 0-.937.725Z",
    fill: "#376996"
  }))));
};
export default SvgRedo;